const getters = {
  getPersonalLines: (state) => state.personalLines,
  getPersonalLinesMeta: (state) => state.personalLinesMeta,
  getQuickViews: (state) => state.quickViews,
  getPersonalLine: (state) => state.personalLine,
  getListProductCategory: (state) => state.listProductCategory,
  getListInsuranceBranch: (state) => state.listInsuranceBranch,
};

export default getters;
